/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { MRT_Localization_PT_BR } from "material-react-table/locales/pt-BR";
import "./style.scss";
import { DeleteApi, GetApi, PostApi } from "../services/auth";
import { isValid } from "../services/utils";
import { Button, CustomInput } from "src/Components/customInput";

import { ReactComponent as Add } from "src/Assets/Icons/add.svg";
import { ReactComponent as Close } from "src/Assets/Icons/close.svg";
import DeleteIcon from "@mui/icons-material/Delete";
import showToast from "../services/toastyService";

export default function Movimentacao({ darkMode }) {
  const [data, setData] = useState([]);
  const [filterData, setFilterData] = useState([]);

  const tableTheme = useMemo(() => {
    return createTheme({
      palette: {
        mode: darkMode ? "dark" : "light",
        primary: { main: darkMode ? "#90caf9" : "#1976d2" },
        background: { default: darkMode ? "#121212" : "#ffffff" },
        text: { primary: darkMode ? "#ffffff" : "#000000" },
      },
      typography: {
        button: { textTransform: "none", fontSize: "1rem" },
      },
      components: {
        MuiTooltip: {
          styleOverrides: {
            tooltip: { fontSize: "1.1rem" },
          },
        },
        MuiSwitch: {
          styleOverrides: {
            thumb: {
              color: darkMode ? "#ffffff" : "#000000",
            },
          },
        },
      },
    });
  }, [darkMode]);

  const [showPopup, setShowpoup] = useState(false);
  const [novaMovimentacao, setNovaMovimentacao] = useState({});
  const [camposVazios, setCamposVazios] = useState([]);

  const [showNewBanco, setNewBanco] = useState(false);
  const [novoBanco, setNovoBanco] = useState({});

  const [selectedVenda, setSelectedVenda] = useState({});

  function HandleAdd() {
    setCamposVazios([]);

    const newData = {
      Cambio_Contratado: novaMovimentacao.cambio,
      Taxa_de_Cambio: novaMovimentacao.taxa,
      Data_do_Cambio: novaMovimentacao.data,
      Banco_id: novaMovimentacao.banco,
      Modalidade: novaMovimentacao.modalidade,
      Exportador: selectedVenda.Exportador || novaMovimentacao.exportador,
      Moeda: selectedVenda.Moeda || novaMovimentacao.moeda,
      Venda_id: novaMovimentacao.nvnp,
    };

    const campos_vazios = Object.entries(newData)
      .filter(([campo]) => campo !== "Venda_id")
      .filter(
        ([_, valor]) => valor === null || valor === undefined || valor === ""
      )
      .map(([campo]) => campo);

    setCamposVazios(campos_vazios);

    if (campos_vazios.length > 0) {
      return;
    }

    PostApi("cambios", newData).then(() => {
      setShowpoup(false);
      GetInfo();
    });
  }

  function HandleAddBanco() {
    const newData = {
      Nome: novoBanco.Nome,
    };

    console.log(newData);

    PostApi("bancos", newData).then(() => {
      setNewBanco(false);
      searchBancos();
    });
  }

  const columns = useMemo(
    () => [
      { accessorKey: "Modalidade", header: "Modalidade" },
      {
        accessorKey: "NomeBanco",
        header: "Banco",
      },
      {
        accessorKey: "Moeda",
        header: "Moeda",
        Cell: ({ cell }) => formatarMoeda(cell.getValue()),
      },
      { accessorKey: "Exportador", header: "Exportador" },
      {
        accessorKey: "Cambio_Contratado",
        header: "Câmbio Contratado",
        Cell: ({ cell, row }) =>
          formatarValor(cell.getValue(), row.original.Moeda),
      },
      {
        accessorKey: "Taxa_de_Cambio",
        header: "Taxa de Câmbio",
        Cell: ({ cell }) => formatarValor(cell.getValue()),
      },
      {
        accessorKey: "Data_do_Cambio",
        header: "Data do Câmbio",
        Cell: ({ cell }) => formatarData(cell.getValue()),
      },
      {
        accessorKey: "NV",
        header: "NV/VP",
        Cell: ({ row }) =>
          isValid(row.original.NV)
            ? `${row.original.Exportador === "Nicchio Café Ltda" ? "NV" : "VP"} - ${row.original.NV || ""}`
            : "",
      },
    ],
    []
  );

  useEffect(() => {
    if (!isValid(data)) {
      GetInfo();
    }
  }, []);

  function GetInfo() {
    GetApi("cambios")
      .then((res) => {
        setData(res?.data.cambios || []);
        showToast("success", res.message);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const [allBancos, setAllBancos] = useState([]);
  const [allVendas, setAllVendas] = useState([]);

  function searchBancos() {
    if (!isValid(allBancos)) {
      GetApi("bancos")
        .then((res) => {
          setAllBancos(res?.data?.bancos);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
  function searchVendas() {
    if (!isValid(allBancos)) {
      GetApi("vendas")
        .then((res) => {
          setAllVendas(res?.data?.vendas);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  useEffect(() => {
    searchBancos();
    searchVendas();
  }, []);

  useEffect(() => {
    const newData = data.map((item) => {
      const venda = allVendas.find((v) => v?.Venda_id === item?.Venda_id);

      return {
        ...item,
        NV: venda ? venda.NV : "",
        NomeBanco: item.banco.Nome,
      };
    });

    setFilterData(newData);
  }, [allVendas, data]);

  function formatarMoeda(moeda) {
    switch (moeda) {
      case "USD":
        return "Dólar (USD)";
      case "EUR":
        return "Euro (EUR)";
      default:
        return "Real (BRL)";
    }
  }

  function formatarValor(valor, moeda = "BRL") {
    if (valor == null || isNaN(valor)) {
      switch (moeda) {
        case "USD":
          return "US$ 0,00";
        case "EUR":
          return "€ 0,00";
        default:
          return "R$ 0,00";
      }
    }

    switch (moeda) {
      case "USD":
        return valor.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
        });
      case "EUR":
        return valor.toLocaleString("de-DE", {
          style: "currency",
          currency: "EUR",
          minimumFractionDigits: 2,
        });
      default:
        return valor.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        });
    }
  }

  function formatarData(dataStr) {
    if (!dataStr) return "";
    const data = new Date(dataStr);
    if (isNaN(data)) return dataStr;
    return data.toLocaleDateString("pt-BR", { timeZone: "UTC" });
  }

  function getCambioAContratar(venda) {
    const valorDaVenda = venda?.PV * venda?.Quantidade;
    const filtrados = data.filter((item) => item?.Venda_id === venda?.Venda_id);
    const cambioContratadoTotal = filtrados.reduce(
      (total, item) => total + (item.Cambio_Contratado || 0),
      0
    );

    const novoCambio = parseFloat(novaMovimentacao.cambio) || 0;

    const cambioAContratar =
      valorDaVenda - (cambioContratadoTotal + novoCambio);

    return cambioAContratar;
  }

  function getCambioAContratarRAW(venda) {
    const valorDaVenda = venda?.PV * venda?.Quantidade;
    const filtrados = data.filter((item) => item?.Venda_id === venda?.Venda_id);
    const cambioContratadoTotal = filtrados.reduce(
      (total, item) => total + (item.Cambio_Contratado || 0),
      0
    );

    const cambioAContratar = valorDaVenda - cambioContratadoTotal;

    return cambioAContratar;
  }

  return (
    <div className="Movimentacao">
      <button
        className={`-popupFade ${showPopup ? "" : "hide"}`}
        onClick={() => setShowpoup(false)}
      />
      {showPopup && (
        <div className="-popup">
          <h3> Nova Movimentação </h3>

          <div className="content">
            <CustomInput
              Class={
                camposVazios?.includes("Modalidade") &&
                !isValid(novaMovimentacao.modalidade)
                  ? "alert"
                  : ""
              }
              Style="Default"
              Type="select"
              Placeholder="Modalidade"
              OnChange={(e) =>
                setNovaMovimentacao((prev) => ({
                  ...prev,
                  modalidade: e.target.value,
                }))
              }
            >
              <option value="">Selecionar Modalidade</option>
              <option value="Pronto">Pronto</option>
              <option value="Aproveitamento">Aproveitamento</option>
              <option value="ACC">ACC</option>
            </CustomInput>

            <div className="inputBancos">
              <CustomInput
                Class={
                  camposVazios?.includes("Banco_id") &&
                  !isValid(novaMovimentacao.banco)
                    ? "alert"
                    : ""
                }
                Style="Default"
                Type="select"
                Placeholder="Banco"
                OnChange={(e) =>
                  setNovaMovimentacao((prev) => ({
                    ...prev,
                    banco: e.target.value,
                  }))
                }
              >
                <option value="">Selecionar Banco</option>
                {allBancos
                  ?.sort((a, b) => a.Banco_id - b.Banco_id)
                  .map((item, index) => (
                    <option key={index} value={item.Banco_id}>
                      {item.Nome}
                    </option>
                  ))}
              </CustomInput>
              <button
                onClick={() => {
                  setNewBanco(true);
                }}
                title="Adicionar Novo Banco"
              >
                <Add />
              </button>
            </div>

            <div
              className={`label ${getCambioAContratar(selectedVenda) < 0 ? "alert" : ""}`}
            >
              <label>
                Cambio a Contratar:{" "}
                {formatarValor(
                  getCambioAContratar(selectedVenda),
                  selectedVenda.Moeda
                )}
              </label>

              <CustomInput
                Class={
                  camposVazios?.includes("Cambio_Contratado") &&
                  !isValid(novaMovimentacao.cambio)
                    ? "alert"
                    : ""
                }
                Style="Default"
                Type="number"
                Placeholder="Câmbio Contratado"
                OnChange={(e) =>
                  setNovaMovimentacao((prev) => ({
                    ...prev,
                    cambio: e.target.value,
                  }))
                }
              />
            </div>

            <CustomInput
              Class={
                camposVazios?.includes("Taxa_de_Cambio") &&
                !isValid(novaMovimentacao.taxa)
                  ? "alert"
                  : ""
              }
              Style="Default"
              Type="number"
              Placeholder="Taxa de Câmbio"
              OnChange={(e) =>
                setNovaMovimentacao((prev) => ({
                  ...prev,
                  taxa: e.target.value,
                }))
              }
            />

            <CustomInput
              Class={
                camposVazios?.includes("Data_do_Cambio") &&
                !isValid(novaMovimentacao.data)
                  ? "alert"
                  : ""
              }
              Style="Default"
              Type="date"
              Placeholder="Data do Câmbio"
              OnChange={(e) =>
                setNovaMovimentacao((prev) => ({
                  ...prev,
                  data: e.target.value,
                }))
              }
            />

            <CustomInput
              Class={
                novaMovimentacao.modalidade?.toLowerCase() === "acc"
                  ? "disable"
                  : ""
              }
              Style="Default"
              Type="select"
              Placeholder="NV/VP"
              OnChange={(e) => {
                setNovaMovimentacao((prev) => ({
                  ...prev,
                  nvnp: e.target.value,
                }));
                setSelectedVenda(
                  allVendas.find((venda) => venda?.Venda_id === e.target.value)
                );
              }}
            >
              <option value="">Selecionar Venda</option>
              {allVendas?.map((item, index) => {
                if (getCambioAContratarRAW(item) > 0)
                  return (
                    <option key={index} value={item?.Venda_id}>
                      {item.Exportador === "Nicchio Café Ltda"
                        ? "NV - "
                        : "VP - "}
                      {item?.NV}
                    </option>
                  );
                else
                  return (
                    <option
                      value={item?.Venda_id}
                      className="disableOption"
                      disabled
                    >
                      {item.Exportador === "Nicchio Café Ltda"
                        ? "NV - "
                        : "VP - "}
                      {item?.NV}
                    </option>
                  );
              })}
            </CustomInput>

            <CustomInput
              Class={isValid(selectedVenda.Exportador) ? "disable" : ""}
              Style="Default"
              Type="select"
              Placeholder="Exportador"
              OnChange={(e) =>
                setNovaMovimentacao((prev) => ({
                  ...prev,
                  exportador: e.target.value,
                }))
              }
              Value={selectedVenda?.Exportador}
            >
              <option value="">Selecionar Exportador</option>
              <option value="Nicchio Café Ltda">Nicchio Café</option>
              <option value="Vix Café Ltda">Vixport</option>
            </CustomInput>

            <CustomInput
              Class={isValid(selectedVenda.Moeda) ? "disable" : ""}
              Style="Default"
              Type="select"
              Placeholder="Moeda"
              OnChange={(e) =>
                setNovaMovimentacao((prev) => ({
                  ...prev,
                  moeda: e.target.value,
                }))
              }
              Value={selectedVenda?.Moeda}
            >
              <option value="">Selecionar Moeda</option>
              <option value="USD">Dolár (USD)</option>
              <option value="EUR">Euro (EUR)</option>
            </CustomInput>
          </div>

          {camposVazios.length > 1 && <h4> Preencha Todos os campos. </h4>}

          <Button
            ClassName={`icon ${novaMovimentacao.modalidade === "ACC" || getCambioAContratar(selectedVenda) >= 0 ? "" : "disable"}`}
            OnClick={() => HandleAdd()}
          >
            <Add /> Adicionar
          </Button>

          <button className="close" onClick={() => setShowpoup(false)}>
            <Close />
          </button>
        </div>
      )}

      {showNewBanco && (
        <button
          style={{ zIndex: 5 }}
          className={`-popupFade ${showPopup ? "" : "hide"}`}
          onClick={() => setNewBanco(false)}
        />
      )}
      {showNewBanco && (
        <div className="-popup bancoForm">
          <h3> Adicionar Novo Banco </h3>

          <div className="content">
            <CustomInput
              Style="Default"
              Type="text"
              Placeholder="Nome do Banco"
              OnChange={(e) =>
                setNovoBanco((prev) => ({
                  ...prev,
                  Nome: e.target.value,
                }))
              }
              Value={novoBanco.Nome}
            />
          </div>

          <Button ClassName="icon" OnClick={() => HandleAddBanco()}>
            <Add /> Adicionar
          </Button>

          <button className="close" onClick={() => setNewBanco(false)}>
            <Close />
          </button>
        </div>
      )}

      <div className="controls">
        <Button
          ClassName="icon"
          OnClick={() => {
            setShowpoup(true);
            setCamposVazios([]);
          }}
        >
          <Add /> Nova Movimentação
        </Button>
      </div>

      <ThemeProvider theme={tableTheme}>
        <MaterialReactTable
          key={darkMode ? "dark" : "light"}
          columns={columns}
          data={filterData}
          enableRowSelection={false}
          enableGlobalFilter={true}
          enableColumnOrdering={false}
          initialState={{ density: "comfortable" }}
          localization={MRT_Localization_PT_BR}
          enableEditing
          renderRowActions={({ row, table }) => (
            <div style={{ display: "flex", gap: "0.5rem" }}>
              <Button
                ClassName="tableIcon delete"
                OnClick={(e) => {
                  e.stopPropagation();
                  if (window.confirm("Deseja realmente deletar esta venda?")) {
                    DeleteApi("cambios", row.original?.Cambio_id)
                      .then(() => {
                        GetInfo();
                        showToast(
                          "success",
                          "Movimentação deletada com sucesso"
                        );
                      })
                      .catch((err) => {
                        console.error(err);
                        showToast("error", "Erro ao deletar venda");
                      });
                  }
                }}
                Title="Deletar"
              >
                <DeleteIcon />
              </Button>
            </div>
          )}
        />
      </ThemeProvider>
    </div>
  );
}
